export const status = (state) => state.internalCampaigns?.status || 'idle'
export const campaigns = (state) => state.internalCampaigns?.items || []
export const newCampaignsCount = (state) =>
  campaigns(state).filter((campaign) => campaign.is_new).length
export const popupCampaigns = (state) =>
  campaigns(state).filter(
    (campaign) => campaign.is_new && campaign.show_as_popup
  )
